import { render, staticRenderFns } from "./user-bulletin-permissions.vue?vue&type=template&id=6f5a5cbe"
import script from "./user-bulletin-permissions.vue?vue&type=script&lang=js"
export * from "./user-bulletin-permissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports